<template>
	<div class="index-wrap">
		<div :class="{'searchBar': showFiled}" id='searchBar'>
			<div class="nav-box box box-lr box-align-center">
				<div class="flex1">
					<img class="logo-img" src='../../static/images/logo.png' />
				</div>
				<div class="nav-item flex2 box box-lr box-pack-end">
					<ul>
						<li :class="{'active': showAct == 1}" @click="toEvent(1)">
							关于我们
						</li>
						<li :class="{'active': showAct == 2}" @click="toEvent(2)">管理方向</li>
						<li :class="{'active': showAct == 3}" @click="toEvent(3)">
							企业文化
						</li>
						<li :class="{'active': showAct == 4}" @click="toEvent(4)">公司动态</li>
						<li :class="{'active': showAct == 6}" @click="toEvent(6)">人才招聘</li>
						<li :class="{'active': showAct == 7}" @click="toEvent(7)">联系我们</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="banner-box">
			<Banner :banner='banner' v-if='banner'></Banner>
			
			<div class="down-img-box">
				<div class="mouse-box">
					<img src="../../static/images/mouse.png" />
				</div>
				<div class="mouse-down">
					<img class="down-ani" src="../../static/images/down.png" @click="toNavHandler" />
				</div>
			</div>
		</div>
		
		
	
		<div class="page1" id="page1">
			<img style="display: block;" src="../../static/images/page1.png" />
			<div class="page1-box">
				<img src="../../static/images/page1-1.png" />
				<div class="img-info">
					<div class="solid"></div>
				</div>
				<div class="swiper">
					<Swiper :imgData='imgData' v-if='imgData'></Swiper>
				</div>
			</div>
		</div>
		
		<div class="page2" id="page2">
			<div class="title-box">
				<img src="../../static/images/page2-title.png"/>
			</div>
			<div class="img-box box box-lr box-wrap">
				<div class="img1-box">
					<img src="../../static/images/page2-img1.png" />
					
					<div class="more" @click="toModle(1)"></div>
				</div>
				<div class="img1-box">
					<img src="../../static/images/page2-img2.png" />
					<div class="more" @click="toModle(2)"></div>
				</div>
				<div class="img1-box">
					<img src="../../static/images/page2-img3.png" />
					<div class="more" @click="toModle(3)"></div>
				</div>
				<div class="img1-box">
					<img src="../../static/images/page2-img4.png" />
					<div class="more" @click="toModle(4)"></div>
				</div>
			</div>
		</div>
		
		<div class="page3" id="page3">
			<div class="page2-img">
				<img src="../../static/images/page3.jpg" />
			</div>
		</div>
		
		<div class="page4" id="page4">
			<!--<div class="page2-img">
				<img src="../../static/images/page4.jpg" />
			</div>-->
			<div class="page4-content">
				<div class="title">公司动态</div>
				<div class="box box-lr" style="margin-top: 40px">
					<div>
						<img class="banner-pic" src="../../static/images/banner1.jpg" />
					</div>
					<div class="box box-tb  box-pack-around" style="margin-left: 40px">
						<div class="size-32 color-6">凝心聚力，砥砺前行——合纵伟业2020年会暨颁奖盛典圆满举行</div>
						<div class="size-32 color-6" @click="toMore"><<查看更多</div>
					</div>
				</div>
				<div class="box box-lr">
					<div>
						<img class="banner-pic" src="../../static/images/des8.jpg" />
					</div>
					<div class="box box-tb  box-pack-around" style="margin-left: 40px">
						<div class="size-32 color-6">赢在合众!决战双十一，有我必胜!</div>
						<div class="size-32 color-6"  @click="toMore"><<查看更多</div>
					</div>
				</div>
			</div>
			
			<!--<div class="more" @click="toMore">
				<div class="btn"></div>
			</div>
			
			<div class="more2" @click="toMore">
				<div class="btn"></div>
			</div>-->
		</div>
		
		<div class="page5">
			<div class="page2-img">
				<img src="../../static/images/page5.jpg" />
			</div>
		</div>
		
		<div class="page6" id="page6">
			<div class="page2-img">
				<img src="../../static/images/page6.png" />
			</div>
		</div>
		<div class="joinUs-box box box-lr">
			<div class="flex1 box box-tb">
				<div class="box box-lr box-align-center">
					<div><img src="../../static/images/new1.png" /></div>
					<div class="font">社会招聘</div>
				</div>
				<div class="box box-lr box-align-center p-l" @click="joinHandler(1)">
					<div><img src="../../static/images/sec1.png" /></div>
					<div class="p-r">APP招商经理</div>
				</div>
				<div class="box box-lr box-align-center p-l" @click="joinHandler(2)">
					<div><img src="../../static/images/sec1.png" /></div>
					<div class="p-r">开发组长/主管</div>
				</div>
				<div class="box box-lr box-align-center p-l" @click="joinHandler(3)">
					<div><img src="../../static/images/sec1.png" /></div>
					<div class="p-r">跨境电商运营</div>
				</div>
				<div class="box box-lr box-align-center p-l" @click="joinHandler(4)">
					<div><img src="../../static/images/sec1.png" /></div>
					<div class="p-r">销售主管/组长</div>
				</div>
				<div class="box box-lr box-align-center p-l" @click="joinHandler(5)">
					<div><img src="../../static/images/sec1.png" /></div>
					<div class="p-r">产品开发/采购专员</div>
				</div>
				<div class="box box-lr box-align-center p-l" @click="joinHandler(6)">
					<div><img src="../../static/images/sec1.png" /></div>
					<div class="p-r">招商专员</div>
				</div>
				<div class="box box-lr box-align-center p-l" @click="joinHandler(7)">
					<div><img src="../../static/images/sec1.png" /></div>
					<div class="p-r">速卖通客服专员</div>
				</div>
				
			</div>
			<div class="flex1">
				<div class="box box-lr box-align-center">
					<div><img src="../../static/images/new2.png" /></div>
					<div class="font">校园招聘</div>
				</div>
				<div class="box box-lr box-align-center p-l" style="color: rgb(51,170,213);">
					<div><img src="../../static/images/sec2.png" /></div>
					<div class="p-r">2019校园招聘计划</div>
				</div>
			</div>
		</div>
		
		<div class="page7" id="page7">
			<div class="page2-img">
				<img src="../../static/images/page7.jpg" />
			</div>
		</div>
		
		<div class="bg-modle" v-if="showModle" @click="closeHandler"></div>
		<div class="modle-box" v-if="showModle">
			<div class="img-box">
				<img :src="page3Img" />
			</div>
		</div>
		
		<div class="bg-modle" v-if="showJoin" @click="closeHandler"></div>
		<div class="joinModle-box" v-if="showJoin" @click="closeHandler">
			<div class="img-box">
				<img :src="joinImg" />
			</div>
			
			<div class="btn">
				<div class="msg"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Banner from '@/components/Banner'
	import Swiper from '@/components/Swiper'
	export default {
		name: 'index',
		components: {
			Banner,
			Swiper
		},
		data() {
			return {
				showAct: 1,
				showModle: false,
				showJoin: false,
				showFiled: false,
				page3Img: require('../../static/images/page3-img1.jpg'),
				joinImg: require('../../static/images/join1.jpg'),
				imgData: [
					require('../../static/images/img1.png'),
					require('../../static/images/img2.png'),
					require('../../static/images/img3.png'),
					require('../../static/images/img4.png'),
					require('../../static/images/img5.png'),
					require('../../static/images/img6.png'),
					require('../../static/images/img7.png')
				],
				  banner: [
			      	require('../../static/images/banner1.jpg'),
			      	require('../../static/images/banner3.jpg'),
			      	require('../../static/images/banner4.jpg')
			      ],
			}
		},
		mounted() {
			
			this.$nextTick(() => {
				window.addEventListener('scroll', this.handleScroll)
			})
			
			
		},
		destroyed () {
		  window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleScroll(event) {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
  				let offsetTop = document.querySelector('#searchBar').getBoundingClientRect().y

  				if (scrollTop >= 840 && scrollTop < 940) {
  					this.showAct = 1
  				} else if (scrollTop >= 2061 && scrollTop < 2161) {
  					this.showAct = 2
  				} else if (scrollTop >= 2920 && scrollTop < 3020) {
  					this.showAct = 3
  				} else if (scrollTop >= 3770 && scrollTop < 3870) {
  					this.showAct = 4
  				} else if (scrollTop >= 6530 && scrollTop < 6800) {
  					this.showAct = 6
  				} else if (scrollTop >= 7500 && scrollTop < 7600) {
  					this.showAct = 7
  				}
				
  				
  				if (scrollTop > (offsetTop + 800)) {
  					this.showFiled = true
  				} else {
  					this.showFiled = false
  				}
				
            },
			toEvent(index) {
				this.showAct = index
				const _id = `#page${index}`
				const returnEle = document.querySelector(_id);
			    if (!!returnEle) {
			      returnEle.scrollIntoView(true);
			    }
			},
			toNavHandler() {
				window.scrollTo(0, window.screen.height)
			},
			toModle(index) {
				const img = require('../../static/images/page3-img'+index+'.jpg')
				this.page3Img = img
				this.showModle = true
			},
			closeHandler() {
				this.showModle = false
				this.showJoin = false
			},
			toMore() {
				this.$router.push({
					path: 'More'
				})
			},
			joinHandler(index) {
				const img = require('../../static/images/join'+index+'.jpg')
				this.joinImg = img
				this.showJoin = true
				
			}
		}
	}
</script>

<style lang="less" scoped>
	@keyframes downAni{
		10%,20% {
			transform: translateY(0px);
			opacity: 1;
		}
		70%, 90%{
			transform: translateY(10px);
		}
		100% {
			transform: translateY(0);
			opacity: 0;
		}
		
	}
	.joinModle-box {
		position: fixed;
		top: 2%;
		left: 0;
		width: 100%;
		text-align: center;
		z-index: 1000;
		.img-box {
			width: 50%;
			margin: 0 auto;
		}
		.btn {
			position: absolute;
			left: 0;
			bottom: 0;
			width: 100%;
			text-align: center;
			padding-bottom: 18px;
			margin-left: 10px;
			.msg {
				width: 240px;
				height: 60px;
				margin: 0 auto;
			}
		}
		img {
			width: 100%;
		}
	}
	.modle-box {
		position: fixed;
		top: 50%;
		left: 50%;
		width: 1200px;
		margin-left: -600px;
		margin-top: -300px;
		text-align: center;
		z-index: 1000;
		.img-box {
			width: 1200px;
			margin: 0 auto;
		}
	}
	.index-wrap {
		width: 100%;
		height: 100%;
		overflow: hidden;
		.joinUs-box {
			width: 960px;
			margin: 20px auto 0;
			.font {
				font-size: 20px;
				color: #000000;
				margin-left: 10px;
			}
			.p-r {
				margin-left: 20px;
			}
			.p-l {
				padding-left: 40px;
				margin-bottom: 10px;
				color: rgb(233,153,30);
				cursor: pointer;
				img {
					vertical-align: middle;
				}
			}
		}
		.page6,.page7 {
			width: 100%;
			margin-top: 30px;
			img {
				width: 100%;
			}
		}
		.page5 {
			position: relative;
			width: 100%;
			margin-top: 30px;
			img {
				width: 100%;
			}
		}
		.page4 {
			position: relative;
			width: 100%;
			margin-top: 30px;
			.page4-content {
				width: 1200px;
				margin: 0 auto;
				.banner-pic {
					width: 500px;
					height: 320px;
				}
				.title {
					width: 100%;
					text-align: center;
					font-size: 50px;
					font-weight: bold;
					color: #000;
				}
			}
			.more2 {
				position: absolute;
				bottom: 6.5%;
				left: 0;
				width: 100%;
				margin-left: 110px;
				.btn {
					width: 150px;
					margin: 0 auto;
					height: 30px;
				}
			}
			.more {
				position: absolute;
				top: 50%;
				left: 0;
				width: 100%;
				margin-top: -15px;
				margin-left: 110px;
				.btn {
					width: 150px;
					margin: 0 auto;
					height: 30px;
				}
			}
			img {
				width: 100%;
			}
		}
		.page3 {
			width: 100%;
			margin-top: 30px;
			img {
				width: 100%;
			}
		}
		.page2 {
			width: 100%;
			text-align: center;
			.img-box {
				width: 1200px;
				margin: 0 auto;
				.img1-box {
					position: relative;
					margin-right: 5px;
					.more {
						position: absolute;
						bottom: 26px;
						left: 50%;
						margin-left: -60px;
						width: 110px;
						height: 30px;
					}
					&:last-child {
						margin-right: 0;
					}
					img {
						width: 592px;
						height: 335px;
					}
				}
			}
			.title-box {
				img {
					width: 1155px;
					height: 208px;
				}
			}
		}
		.page1 {
			width: 100%;
			.page1-box {
				position: relative;
				width: 100%;
				height: 577px;
				
			}
			.swiper {
				position: absolute;
				bottom: 6%;
				left: 0;
				width: 100%;
				text-align: center;
				z-index: 2;
			}
			.img-info {
				position: absolute;
				top: 40%;
				left: 0;
				width: 100%;
				text-align: center;
				z-index: 2;
				.solid {
					width: 1250px;
					margin: 0 auto;
					height: 4px;
					background: #ffffff;
				}
				
			}
			
			img {
				width: 100%;
				height: 577px;
			}
		}
		.searchBar {
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1001;
			width: 100%;
			background: #ffffff;
		}
		.nav-box {
			width: 1200px;
			margin: 0 auto;
			height: 60px;
			.logo-img {
				width: 200px;
				height: 51px;
			}
			.nav-item {
				ul {
					list-style-type: none;
					li {
						float: left;
						padding-right: 20px;
						cursor: pointer;
						&.active {
							color: #FF8F1B;
						}
						&:last-child {
							padding-right: 0;
						}
					}
				}
			}
		}
		.banner-box {
			position: relative;
			width: 100%;
			text-align: center;
			overflow: hidden;
			box-sizing: border-box;
			.down-img-box {
				position: absolute;
				bottom: 5%;
				left: 0;
				width: 100%;
				text-align: center;
				z-index: 2;
				.down-ani {
					transition: all 2s;
					animation: downAni 2s infinite;
				}
				.mouse-down {
					img {
						width: 44px;
						height: 25px;
					}
				}
				.mouse-box {
					img {
						width: 44px;
						height: 60px;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/Index.vue